import { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '~/shadcn/ui/dialog'
import { Button } from '~/shadcn/ui/button/button'
import { Spinner } from '~/shadcn/ui/spinner'
import { FieldError } from '~/shadcn/ui/field'
import { useLocalNotifications } from '~/@mid_ui/local-notifications/useLocalNotifications'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onConfirm: () => Promise<unknown>
  onSuccess?: () => void
}

export function DeactivateDialog({
  open,
  onOpenChange,
  onConfirm,
  onSuccess,
}: Props) {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const { setNotification } = useLocalNotifications()

  async function handleConfirm() {
    setError(null)
    setIsSubmitting(true)
    try {
      await onConfirm()
      onOpenChange(false)
      setNotification('success', 'Ambasádor bol deaktivovaný.')
      onSuccess?.()
    } catch (err) {
      setError(getApiErrorMessage(err, 'Ambasádora sa nepodarilo deaktivovať.'))
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[min(30rem,calc(100%-2rem))] w-full gap-10 px-6 md:px-15 pt-12 pb-13">
        <div className="flex flex-col items-center gap-5 text-center">
          <DialogTitle className="text-2xl font-semibold">
            Naozaj chcete deaktivovať ambasádora?{' '}
          </DialogTitle>
          <DialogDescription className="text-base font-medium text-primary">
            V prípade potreby môžete ambasádora neskôr opäť aktivovať.
          </DialogDescription>
        </div>

        {error && <FieldError className="self-center">{error}</FieldError>}

        <Button
          type="button"
          onClick={handleConfirm}
          disabled={isSubmitting}
          className="h-[45px] self-center">
          {isSubmitting && <Spinner className="size-5" />}
          Deaktivovať
        </Button>
      </DialogContent>
    </Dialog>
  )
}
